export default __webpack_public_path__ + "static/media/laughingMan.e6fb5bcf.jpg";